import { CameraIcon } from '../../../../../assets/icons/common';
import Button from '../../../../../components/Button';
import styles from './style.module.scss';
import { useState } from 'react';
import KYCWizardModal from './KYCWizardModal';

interface Props {
    kycStatus: string;
    facePhoto: string | null;
};

export default function Identifying(props: Props) {
    const { facePhoto, kycStatus } = props;
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <div className={styles.wrapper}>
            <div className={styles.content}>
                <div className={styles.content_headbar}>
                    <span className={styles.content_headbar_title}>Personal photo</span>
                </div>
                <div className={styles.content_main}>
                    {facePhoto ? <div className={styles.content_main_face}>
                        <img src={facePhoto} alt='' />
                    </div> : <div className={styles.content_main_empty}>
                        <CameraIcon />
                        <span>No data</span>
                    </div>}
                </div>
            </div>
            <div className={styles.content}>
                <div className={styles.content_headbar}>
                    <span className={styles.content_headbar_title}>KYC status</span>
                </div>
                <div className={styles.content_main}>
                    <span
                        className={styles.content_main_status}
                        data-kyc-status={kycStatus}
                    >
                        {kycStatus === 'approved' && 'Approved'}
                        {kycStatus === 'notApproved' && 'Not approved'}
                    </span>
                    {kycStatus === 'notApproved' && <Button
                        text='KYC now'
                        type='Primary'
                        size='sm'
                        onClick={() => setIsModalOpen(true)}
                        className={styles.content_main_kycBtn}
                    />}
                </div>
            </div>
            <KYCWizardModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
        </div>
    );
};